import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ShoppingBag, Zap, MapPin, Mail, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

const AboutPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="font-sans">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 transition-colors"
            aria-label="Go back"
          >
            <ChevronLeft className="w-6 h-6 relative mb-[2px]" />
          </button>
          <h1 className="text-xl font-bold">{t("aboutPage.title")}</h1>
        </div>
      </header>

      {/* Content */}
      <div className="bg-white dark:bg-transparent max-w-2xl mx-auto px-4 py-8 space-y-8">
        {/* Brand */}
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-100/10 mb-2">
            <ShoppingBag className="w-8 h-8 text-primary-100" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">The Kirana Point</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t("aboutPage.by")}{" "}
            <span className="font-semibold text-gray-700 dark:text-gray-200">
              World Creator Ventures
            </span>
          </p>
        </div>

        {/* Description */}
        <p className="text-sm text-gray-600 dark:text-gray-300 text-center leading-relaxed">
          {t("aboutPage.description")}
        </p>

        {/* Highlights */}
        <div className="grid grid-cols-1 gap-4">
          <div className="flex items-start gap-3 bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm">
            <Zap className="w-5 h-5 text-primary-100 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-gray-800 dark:text-white">{t("aboutPage.deliveryTitle")}</p>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                {t("aboutPage.deliveryDesc")}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm">
            <MapPin className="w-5 h-5 text-primary-100 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-gray-800 dark:text-white">{t("aboutPage.locationTitle")}</p>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                {t("aboutPage.locationDesc")}
              </p>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm space-y-3">
          <p className="text-sm font-semibold text-gray-800 dark:text-white">{t("aboutPage.contactTitle")}</p>
          <a
            href="mailto:support@worldcreatorventures.com"
            className="flex items-center gap-2 text-sm text-primary-100 hover:underline"
          >
            <Mail className="w-4 h-4 flex-shrink-0" />
            support@worldcreatorventures.com
          </a>
          <a
            href="tel:+917050009899"
            className="flex items-center gap-2 text-sm text-primary-100 hover:underline"
          >
            <Phone className="w-4 h-4 flex-shrink-0" />
            +91 70500 09899
          </a>
        </div>

        <p className="text-xs text-center text-gray-400 dark:text-gray-500">
          {t("aboutPage.copyright", { year: new Date().getFullYear() })}
        </p>
      </div>
    </div>
  );
};

export default AboutPage;
